<div class="main-content mb-4 mx-lg-4 mx-md-4 mx-sm-0 px-sm-4 px-3">
	<ms-page-title />

	<!-- Page Header -->
	<div class="page-title-wrapper">
		<div class="d-flex justify-content-between flex-row flex-wrap gap-3 align-items-start">
			<div>
				<!-- Search Input Group -->
				<div class="input-group position-relative">
					<input id="search" type="text" class="form-control form-control-solid ps-13 pe-5"
						placeholder="Search Budgets" aria-label="Search Budgets"
						[ngModel]="userSessionService.budgetsFilter.searchTerm"
						(ngModelChange)="userSessionService.budgetsFilter.searchTerm = $event"
						(keyup.enter)="loadBudgets(false)" aria-describedby="search-description">

					@if (userSessionService.budgetsFilter.searchTerm) {
						<button class="btn btn-link position-absolute top-50 translate-middle-y p-0 border-0 bg-transparent mx-2 input-group-clear-button"
							type="button" (click)="clearSearch()" aria-label="Clear search">
							<fa-duotone-icon icon="xmark" class="text-secondary fs-6" secondaryOpacity="0.9" size="lg" />
						</button>
					}

					<div class="input-group-append">
						<button class="btn btn-primary rounded-0 rounded-end" type="button"
							(click)="loadBudgets(false)" id="button-addon2">
							Search
						</button>
					</div>
				</div>
				<!-- Search Input Group -->
				<div id="search-description" class="ps-2 mt-2 text-muted small fst-italic">
					Search by name or year
				</div>
			</div>

			<div class="d-flex gap-3">
				<ms-budget-search-filter (filterApplied)="filterApplied()" />

				<ms-sort-dropdown [sortOptions]="sortOptions" [(selectedSortOption)]="orderBy"
					(selectedSortOptionChange)="setSortOrder($event)"></ms-sort-dropdown>

				<a *ifHasPermission="{requiredPermissions: [FinancialsPermission.CreateBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}"
					class="btn btn-primary"
					[routerLink]="['/budgets/create']">
					<fa-duotone-icon icon="plus" secondaryOpacity="0.9" class="d-none d-sm-inline me-2" />
					Create Budget
				</a>
			</div>
		</div>
	</div>

	<div>
		<div class="d-flex flex-wrap">
			<div class="mb-0 text-start flex-grow-0 w-50" #jumpToElementMobile>
				Showing: {{ budgetList().length }} of {{ totalCount | number }}
			</div>
		</div>

		<!-- Table Start -->
		<div class="table-responsive d-none d-sm-block">
			<table msResponsiveTable class="table table-hover fixed-header placeholder-glow">
				<thead #jumpToElement>
					<tr>
						<th msResponsiveTableColumn="name" [priority]="1" scope="col" class="sortable" (click)="toggleSortDirection('Name')">
							Name
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy === budgetListSortOptions.NameAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy === budgetListSortOptions.NameDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="year" [priority]="2" scope="col" class="sortable numeric-column" (click)="toggleSortDirection('Year')">
							Year
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy === budgetListSortOptions.YearAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy === budgetListSortOptions.YearDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="frequency" [priority]="4" scope="col" class="sortable" (click)="toggleSortDirection('Frequency')">
							Frequency
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy === budgetListSortOptions.FrequencyAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy === budgetListSortOptions.FrequencyDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="status" [priority]="3" scope="col" class="sortable" (click)="toggleSortDirection('Status')">
							Status
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy === budgetListSortOptions.StatusAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy === budgetListSortOptions.StatusDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="modified" [priority]="5" scope="col" class="sortable" (click)="toggleSortDirection('Modified')">
							Modified
							<fa-duotone-icon icon="sort" class="ms-1" size="lg"
								[primaryOpacity]="orderBy === budgetListSortOptions.LastModifiedAsc ? '0.9' : '0.3'"
								[secondaryOpacity]="orderBy === budgetListSortOptions.LastModifiedDesc ? '0.9' : '0.3'" />
						</th>
						<th msResponsiveTableColumn="actions" [priority]="1" class="fixed-header" scope="col">Actions</th>
					</tr>
				</thead>
				<tbody>
					@for (budget of displayBudgets; let i = $index; track budget.budgetId) {
						<tr class="align-middle" [className]="(i % 2 === 0) ? 'even' : 'odd'">
							<td msResponsiveTableColumn="name" [priority]="1">
								<span class="fw-bold text-truncate d-block" [class.placeholder]="isLoading"
										[msTooltip]="budget.name ?? ''" msTooltipOnlyIfTruncated>
									{{ budget.name | noValue }}
								</span>
							</td>
							<td msResponsiveTableColumn="year" [priority]="2" class="numeric-column">
								<span [class.placeholder]="isLoading">{{ budget.year }}</span>
							</td>
							<td msResponsiveTableColumn="frequency" [priority]="4">
								<span [class.placeholder]="isLoading">{{ enumUtilities.convertToLabel(budget.budgetFrequencyId) }}</span>
							</td>
							<td msResponsiveTableColumn="status" [priority]="3">
								<ms-status-badge [status]="budget.status" [isLoading]="isLoading" />
							</td>
							<td msResponsiveTableColumn="modified" [priority]="5">
								<span [class.placeholder]="isLoading">{{ budget.lastModified | orgDate }}</span>
							</td>
							<td msResponsiveTableColumn="actions" [priority]="1">
								<div class="dropdown">
									<button class="btn btn-sm btn-ms-secondary dropdown-toggle" data-bs-toggle="dropdown"
										[class.placeholder]="isLoading">
										Actions
									</button>
									<ul class="dropdown-menu dropdown-menu-end">
										<li>
											<a class="dropdown-item" [routerLink]="['/budgets', budget.budgetId]">
												<fa-duotone-icon icon="clipboard-list" secondaryOpacity="0.3" class="me-2" />Summary
											</a>
										</li>
										<li *ifHasPermission="{requiredPermissions: [FinancialsPermission.UpdateBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
											<a class="dropdown-item"
												[class.disabled]="budget.status === PropertyStatuses.Deleted"
												[attr.aria-disabled]="budget.status === PropertyStatuses.Deleted ? 'true' : null"
												[attr.tabindex]="budget.status === PropertyStatuses.Deleted ? -1 : null"
												[routerLink]="budget.status === PropertyStatuses.Deleted ? null : ['/budgets', budget.budgetId, 'edit']">
												<fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.3" class="me-2" />Edit
											</a>
										</li>
										<li *ifHasPermission="{requiredPermissions: [FinancialsPermission.DeleteBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
										<a class="dropdown-item"
												[class.disabled]="budget.status === PropertyStatuses.Deleted"
												[attr.aria-disabled]="budget.status === PropertyStatuses.Deleted ? 'true' : null"
												[attr.tabindex]="budget.status === PropertyStatuses.Deleted ? -1 : null"
												(click)="budget.status !== PropertyStatuses.Deleted ? confirmBudgetDeletion(budget) : $event.stopPropagation()">
												<fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
											</a>
										</li>
									</ul>
								</div>
							</td>
						</tr>
					}
				</tbody>
				<tfoot ms-pagination [take]="take" (loadMoreInView)="loadMoreInView()" [(skip)]="skip"
					[hasNext]="hasNext" [itemCount]="displayBudgets.length" (jumpToClicked)="jumpToTop($event)">
				</tfoot>
			</table>
		</div>
		<!-- Table End -->

		<!-- Mobile Cards Start -->
		<div id="mobileTableCards" class="d-block d-sm-none">
			@for (budget of displayBudgets; let i = $index; track budget.budgetId) {
				<div class="card d-flex pt-1 d-inline d-sm-none my-3">

					<div class="card-body">
						<div class="right-card-column w-100">
							<div class="d-flex justify-content-between align-items-center gap-2 mb-1">
								<h5 class="card-title mb-0 flex-grow-1" [class.placeholder]="isLoading">{{ budget.name }}</h5>
								<ms-status-badge [status]="budget.status" [isLoading]="isLoading" />
							</div>

							<div class="card-text" [class.placeholder]="isLoading">
								<span class="fw-semibold">Year:</span> {{ budget.year }}
							</div>

							<div class="card-text" [class.placeholder]="isLoading">
								<span class="fw-semibold">Frequency:</span> {{ enumUtilities.convertToLabel(budget.budgetFrequencyId) }}
							</div>

							<div class="card-text" [class.placeholder]="isLoading">
								<span class="fw-semibold">Modified:</span> {{ budget.lastModified | orgDate }}
							</div>
						</div>
					</div>

					<button class="mobile-action-button dropdown-toggle" data-bs-toggle="dropdown"
						[class.placeholder]="isLoading">
						Actions
					</button>
					<ul class="dropdown-menu dropdown-menu-end w-75">
						<li>
							<a class="dropdown-item" [routerLink]="['/budgets', budget.budgetId]">
								<fa-duotone-icon icon="clipboard-list" secondaryOpacity="0.3" class="me-2" />Summary
							</a>
						</li>
						<li *ifHasPermission="{requiredPermissions: [FinancialsPermission.UpdateBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
							<a class="dropdown-item"
								[class.disabled]="budget.status === PropertyStatuses.Deleted"
								[attr.aria-disabled]="budget.status === PropertyStatuses.Deleted ? 'true' : null"
								[attr.tabindex]="budget.status === PropertyStatuses.Deleted ? -1 : null"
								[routerLink]="budget.status === PropertyStatuses.Deleted ? null : ['/budgets', budget.budgetId, 'edit']">
								<fa-duotone-icon icon="pen-to-square" secondaryOpacity="0.3" class="me-2" />Edit
							</a>
						</li>
						<li *ifHasPermission="{requiredPermissions: [FinancialsPermission.DeleteBudget], userPermissionOnly: false, dataEntityType: DataEntityTypes.User}">
							<a class="dropdown-item"
								[class.disabled]="budget.status === PropertyStatuses.Deleted"
								[attr.aria-disabled]="budget.status === PropertyStatuses.Deleted ? 'true' : null"
								[attr.tabindex]="budget.status === PropertyStatuses.Deleted ? -1 : null"
								(click)="budget.status !== PropertyStatuses.Deleted ? confirmBudgetDeletion(budget) : $event.stopPropagation()">
								<fa-duotone-icon icon="trash" secondaryOpacity="0.9" class="me-2" />Delete
							</a>
						</li>
					</ul>
				</div>
			}
			<div ms-in-view-port (inViewPort)="loadMoreInView()" ms-pagination [take]="take" [(skip)]="skip"
				[hasNext]="hasNext" [itemCount]="displayBudgets.length" (jumpToClicked)="jumpToTop($event)">
			</div>
		</div>
		<!-- Mobile Cards End -->
	</div>

	<ms-confirmation-modal #budgetListConfirmationModalRef modalId="budgetListConfirmationModal"
		[enableNotes]="true" [isNoteRequired]="false" confirmButtonText="Yes" cancelButtonText="No"
		[(isSubmitting)]="isSubmitting"
		(confirmed)="confirmationConfirmFunction($event)" (cancelled)="confirmationCancelFunction()" />

	<ms-info-modal #budgetListInfoModalRef modalId="budgetListInfoModal" />
</div>
